import { Clock, PoundSterling, TrendingDown } from "lucide-react";
import { FadeUp } from "./Reveal";

const cards = [
  {
    n: "01",
    icon: Clock,
    title: "Buried in Admin & Reports",
    body: "Advisers losing billable client hours to Suitability Reports, LOAs, and platform administration.",
  },
  {
    n: "02",
    icon: PoundSterling,
    title: "Skyrocketing UK Salaries",
    body: "Inability to justify £40k+ local salaries plus NI, pension, and recruitment overheads.",
  },
  {
    n: "03",
    icon: TrendingDown,
    title: "Stalled Growth",
    body: "Firms turning away new clients because backend capacity is stretched to the limit.",
  },
];

export const Problem = () => (
  <section className="pt-12 md:pt-16 pb-24 md:pb-36 relative z-10" data-testid="problem-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex items-center gap-4 mb-8">
        <span className="font-sans text-xs uppercase tracking-[0.28em] text-verdigris">
          The Problem
        </span>
      </div>
      <FadeUp>
        <h2 className="font-serif text-petrol text-4xl md:text-6xl tracking-tight max-w-3xl leading-[1.02]">
          The capacity bottleneck in UK financial advice.
        </h2>
      </FadeUp>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-petrol/15 mt-16 md:mt-24 border border-petrol/15">
        {cards.map((c, i) => {
          const Icon = c.icon;
          return (
            <FadeUp
              key={c.n}
              delay={i * 0.12}
              className="group bg-parchment p-8 md:p-12 relative overflow-hidden"
              data-testid={`problem-card-${i + 1}`}
            >
              <span className="absolute -top-4 right-4 font-serif text-[7rem] leading-none text-petrol/[0.06] select-none">
                {c.n}
              </span>
              <Icon className="text-verdigris mb-10" size={34} strokeWidth={1.4} />
              <h3 className="font-serif text-2xl md:text-3xl text-petrol mb-4 leading-tight">
                {c.title}
              </h3>
              <p className="font-sans text-petrol/70 leading-relaxed">{c.body}</p>
            </FadeUp>
          );
        })}
      </div>
    </div>
  </section>
);
